

import {
    SET_PAY_RATES_TYPE,
    SET_PAY_RATES_DATA,
    SET_PAY_RATE,
    SET_PAY_RATES_STAFF_DATA,
} from '../types/types';


export const setPayRatesType = (value) => {
    return {
        type: SET_PAY_RATES_TYPE,
        payload: { data: value },
    };
};

export const setPayRatesData = (value) => {
    return {
        type: SET_PAY_RATES_DATA,
        payload: { data: value },
    };
}

export const setPayRate = (value) => {
    return {
        type: SET_PAY_RATE,
        payload: { data: value },
    };
}

export const setPayRatesByStaff = (value) => {
    return {
        type: SET_PAY_RATES_STAFF_DATA,
        payload: { data: value },
    };
}

export const setPayrollOverview = (value) => {
    return {
        type: "SET_PAYROLL_OVERVIEW",
        payload: { data: value },
    };
}
export const setPayrollDetails= (value) => {
    return {
        type: "SET_PAYROLL_DETAILS",
        payload: { data: value },
    };
}